// import React, { useEffect, useState } from "react";
// import { connect } from 'react-redux';
// import { requestServerGet, requestServerPost, selectBrand, selectPage, updateGlobalSearch } from '../../actions';
// import MainLayout from '../../components/layouts/main';
// import Constants from '../../data/constants';
// import { Table, Modal, Button, Pagination, Popover } from "antd";
// import LogFilter from "../../components/views/LogFilter";
// import moment from "moment";
// import ScreenIconView from "../../components/views/ScreenIconView";

// function MediaLogPage(props) {
//     const [mediaLogData, setMediaLogData] = useState([]);
//     const [modalVisible, setModalVisible] = useState(false);
//     const [selectedResponse, setSelectedResponse] = useState(null);
//     const [filter, setFilter] = useState(null);
//     const [page,setPage]  =useState(1);
//     const [perPage,setPerPageage]  =useState(20);
//     const [totalRecords,setTotalRecords]  =useState(0);

//     const columns = [
//         {
//             title: "Period Start",
//             dataIndex: "StartTime",
//             key: "StartTime",
//         },
//         {
//             title: "Period End",
//             dataIndex: "EndTime",
//             key: "EndTime",
//         },
//         {
//             title: "Media Name",
//             dataIndex: "FileName",
//             key: "FileName",
//         },
//         {
//             title: "Type",
//             dataIndex: "FileType",
//             key: "FileType",
//         },
//         {
//             title: "Screens",
//             dataIndex: "ScreenNames",
//             key: "ScreenNames",
//             render:arr => {
//                 const screenNames = arr.map((name, index) => (
//                     <div key={index}>{name}</div>
//                 ));
//                 return <Popover content={screenNames}><div style={{display:"flex", justifyContent:"start", alignItems:"center", gap:"5px"}}><img src="/cms/assets/svgs/icons/screen_icon_default.svg" style={{width:"15px", height:"15px", cursor:"pointer"}}/> <div style={{display:"inline-block"}}>{arr.length}</div></div></Popover>

//             }
//         },
//         {
//             title: "Play Count",
//             dataIndex: "TotalCountTime",
//             key: "TotalCountTime",
//         },
//         {
//             title: "Total Duration (s)",
//             dataIndex: "TotalDurationSeconds",
//             key: "TotalDurationSeconds",
//         },
//     ];

//     useEffect(() => {
//         get7DaysLog();
//     }, []);

//     useEffect(() => {
//         if (filter && filter.dateRange && filter.dateRange.length > 1) {
//             const startDate = moment(filter.dateRange[0]).format("YYYY-MM-DD")
//             const endDate = moment(filter.dateRange[1]).format("YYYY-MM-DD")
//             console.log("filter " + startDate)
//             console.log("filter " + endDate)

//             getActivityLogsData({ startdate: startDate, enddate: endDate });
//         }
//         else
//         {

//             get7DaysLog();
//         }
//     }, [filter, page])

//     const get7DaysLog = () => {

//         const endDate = moment().format("YYYY-MM-DD")
//         const startDate = moment().subtract(7, 'days').format("YYYY-MM-DD");
//         getActivityLogsData({ startdate: startDate, enddate: endDate, perpage:perPage, page:page });
//     }

//     const getActivityLogsData = (params) => {

//         const { usertoken, requestServerGet, selectedBrandData } = props;

//         if (!selectedBrandData)
//             return;

//         requestServerGet("get_dashboardmedialog", { brandid: selectedBrandData.BrandID, perpage:perPage, page:page, ...params }, null, (response) => {
//             console.log("Activity Log " + JSON.stringify(response.data))
//             // const options = response.data.map(data => {
//             //     return { value: data.CampaignID, label: data.CampaignName }
//             // })
//             if(response.data.pagination)
//             {
//                 console.log("setTotalRecords " + response.data.pagination.totalrecords)
//                 setTotalRecords(response.data.pagination.totalrecords)
//             }
//             console.log("setMediaLogData " + response.data.data)

//             setMediaLogData(response.data.data)
//             // this.setState({ campaigntDatas: options, campaignOptions: options })
//         }, usertoken)
//     }

//     const onPageChange= (page, pageSize) => {
//         setPage(page);
//     }
//     return (

//         <MainLayout id={Constants.MEDIALOG_PAGE} showTopBarBrandLogo={true} showSearchBar={true}>

//             <div>
//                 <LogFilter onFilterChange={setFilter}></LogFilter>
//                 {/* {JSON.stringify(mediaLogData)} */}
//                 {/* <Table columns={columns} dataSource={mediaLogData} pagination={false} /> */}
//                 {mediaLogData && <Table columns={columns} dataSource={mediaLogData} pagination={{ pageSize: perPage, defaultCurrent:page, pageSize:perPage, total:totalRecords, onChange:onPageChange}} />}
//                 <Modal
//                     title="Response Data"
//                     visible={modalVisible}
//                     onCancel={() => setModalVisible(false)}
//                     footer={null}
//                     width={600}
//                 >
//                     <pre style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify(selectedResponse, null, 2)}</pre>
//                 </Modal>
//             </div>
//         </MainLayout>
//     );
// }

// const mapStateToProps = (state) => {
//     return { userdata: state.userdata, usertoken: state.usertoken, globalSearch: state.globalSearch, selectedBrandData: state.selectedBrandData };
// }

// export default connect(mapStateToProps, { updateGlobalSearch, requestServerGet, requestServerPost, selectBrand, selectPage })(MediaLogPage);

import { DownloadOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
  updateGlobalSearch,
} from "../../actions";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import {
  Table,
  Popover,
  Form,
  DatePicker,
  Select,
  Collapse,
  Tabs,
  Empty,
} from "antd";
import PageLoader from "../../components/PageLoader";
import { motion } from "framer-motion";
import MediaLogFilter from "../../components/views/MediaLogFilter";
import moment from "moment";
import DataHelper from "../../helpers/DataHelper";
import {
  Film,
  Download,
  Monitor,
  Clock,
  TrendingUp,
  Image,
  Video,
  FileText,
} from "lucide-react";
import Animations from "../../animations/Animations";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";
const { RangePicker } = DatePicker;
const { Panel } = Collapse;

const FILE_TYPE_STYLE = {
  image: { bg: "#dbeafe", color: "#2563eb" },
  video: { bg: "#ede9fe", color: "#7c3aed" },
  pdf: { bg: "#fee2e2", color: "#dc2626" },
};
const getTypeStyle = (t) => {
  if (!t) return { bg: "#f1f5f9", color: "#64748b" };
  const k = Object.keys(FILE_TYPE_STYLE).find((k) =>
    t.toLowerCase().includes(k),
  );
  return k ? FILE_TYPE_STYLE[k] : { bg: "#f1f5f9", color: "#64748b" };
};

function MediaLogPage(props) {
  const [mediaLogData, setMediaLogData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [filter, setFilter] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage, setPerPageage] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [screenDatas, setScreenDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterRef = useRef(null);

  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaLog;

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const rangeConfig = {
    rules: [{ type: "array", required: true, message: "Please select time!" }],
  };

  useEffect(() => {
    const { selectedBrandData } = props;

    if (!selectedBrandData) return;

    // reloadLicenses();
    // Fetch licenses data from the server or perform any other side effects here
  }, []);

  const onFinish = (fieldsValue) => {
    // Should format date value before submit.
    const rangeValue = fieldsValue["range-picker"];
    const rangeTimeValue = fieldsValue["range-time-picker"];
    const values = Object.assign(Object.assign({}, fieldsValue), {
      "range-picker": [
        rangeValue[0].format("YYYY-MM-DD"),
        rangeValue[1].format("YYYY-MM-DD"),
      ],
    });
    console.log("Received values of form: ", values);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTimeRange = (range) => {
    const [start, end] = range.split(" - ");

    const formatTime = (timeStr) => {
      const [hour, minute] = timeStr.split(":");
      const h = parseInt(hour, 10);
      const ampm = h >= 12 ? "PM" : "AM";
      const hour12 = h % 12 === 0 ? 12 : h % 12;
      return `${hour12} ${ampm}`;
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  };

  const columns = [
    {
      title: t.colMediaName,
      dataIndex: "FileName",
      key: "FileName",
      render: (text, record) => {
        const { bg, color } = getTypeStyle(record.FileType);
        const icon =
          record.FileType && record.FileType.toLowerCase().includes("video") ? (
            <Video size={14} color={color} />
          ) : record.FileType &&
            record.FileType.toLowerCase().includes("pdf") ? (
            <FileText size={14} color={color} />
          ) : (
            <Image size={14} color={color} />
          );
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                background: bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {icon}
            </div>
            <span style={{ fontWeight: 600, color: "#0f172a", fontSize: 13 }}>
              {text || "—"}
            </span>
          </div>
        );
      },
    },
    {
      title: t.colType,
      dataIndex: "FileType",
      key: "FileType",
      align: "center",
      render: (text) => {
        const { bg, color } = getTypeStyle(text);
        return (
          <span
            style={{
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
              background: bg,
              color,
            }}
          >
            {text || "—"}
          </span>
        );
      },
    },
    {
      title: t.colScreens,
      dataIndex: "ScreenNames",
      key: "ScreenNames",
      align: "center",
      render: (arr) => {
        if (!arr || !arr.length)
          return <span style={{ color: "#94a3b8" }}>—</span>;
        const content = (
          <div style={{ maxWidth: 200 }}>
            {arr.map((name, i) => (
              <div
                key={i}
                style={{
                  padding: "3px 0",
                  fontSize: 12,
                  color: "#334155",
                  borderBottom:
                    i < arr.length - 1 ? "1px solid #f1f5f9" : "none",
                }}
              >
                {name}
              </div>
            ))}
          </div>
        );
        return (
          <Popover
            content={content}
            title={
              <span style={{ fontSize: 12, fontWeight: 700 }}>
                {t.screensPopoverTitle}
              </span>
            }
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                padding: "3px 10px",
                borderRadius: 20,
                background: "#f0f9ff",
                border: "1px solid #bae6fd",
                color: "#0284c7",
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <Monitor size={12} /> {arr.length}
            </span>
          </Popover>
        );
      },
    },
    {
      title: t.colPlayCount,
      dataIndex: "TotalCountTime",
      key: "TotalCountTime",
      align: "center",
      render: (text) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            fontWeight: 700,
            color: "#7c3aed",
            fontSize: 14,
          }}
        >
          <TrendingUp size={13} color="#7c3aed" />
          {text ?? "—"}
        </span>
      ),
    },
    {
      title: t.colDuration,
      dataIndex: "TotalDurationSeconds",
      key: "TotalDurationSeconds",
      align: "center",
      render: (text) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            color: "#64748b",
            fontSize: 13,
          }}
        >
          <Clock size={12} color="#94a3b8" />
          {text ?? "—"}
        </span>
      ),
    },
  ];

  useEffect(() => {
    // setFilter({dateRange:[moment().subtract(8, 'days').format("YYYY-MM-DD"), moment().subtract(1, 'days').format("YYYY-MM-DD")]});
    // getMediaLogs();
  }, []);

  useEffect(() => {
    getMediaLogs();
  }, [filter, page]);

  useEffect(() => {
    console.log("filterRef.current " + filterRef.current);

    if (filterRef.current) {
      const filters = filterRef.current.getCurrentFilters();
      console.log("filters " + JSON.stringify(filters));
      if (!filters.dateRange) {
        var endDate = moment().format("YYYY-MM-DD");
        var startDate = moment().subtract(7, "days").format("YYYY-MM-DD");

        setDateRange([startDate, endDate]);
      }
    }
  }, [filterRef.current]);

  const getMediaLogs = () => {
    console.log("getMediaLogs");
    // var endDate = "";
    // var startDate = "";

    var endDate = moment().format("YYYY-MM-DD");
    var startDate = moment().subtract(7, "days").format("YYYY-MM-DD");

    var screens = undefined;
    var files = undefined;
    if (filter && filter.dateRange && filter.dateRange.length > 1) {
      startDate = moment(filter.dateRange[0]).format("YYYY-MM-DD");
      endDate = moment(filter.dateRange[1]).format("YYYY-MM-DD");
    } else {
      setDateRange([startDate, endDate]);
    }

    if (filter) console.log("filter.screens +  " + filter.screens);

    if (filter && filter.screens && filter.screens.length > 0) {
      screens = filter.screens.join(",");
    }
    if (filter && filter.files && filter.files.length > 0) {
      files = filter.files.join(",");
    }
    getActivityLogsData({
      startdate: startDate,
      enddate: endDate,
      screensid: screens,
      filesid: files,
    });
  };

  const handleScreenSelect = (value) => {
    setSelectedScreens(value);
  };

  const getActivityLogsData = (params) => {
    console.log("getActivityLogsData");
    const { usertoken, requestServerGet, selectedBrandData } = props;

    if (!selectedBrandData) return;

    setLoading(true);

    try {
      console.log("get_dashboardmedialogbyhour");
      requestServerGet(
        "get_dashboardmedialogbyhour",
        {
          brandid: selectedBrandData.BrandID,
          perpage: perPage,
          page: page,
          ...params,
        },
        null,
        (response) => {
          console.log("Activity Log " + JSON.stringify(response.data));
          // const options = response.data.map(data => {
          //     return { value: data.CampaignID, label: data.CampaignName }
          // })

          setTimeout(() => {
            setLoading(false);
          }, 300);
          if (response.data.pagination) {
            console.log(
              "setTotalRecords " + response.data.pagination.totalrecords,
            );
            setTotalRecords(response.data.pagination.totalrecords);
          }
          console.log("setMediaLogData " + response.data.data);

          setMediaLogData(
            response.data.data.sort((a, b) => {
              return new Date(a.date) - new Date(b.date);
            }),
          );
          // this.setState({ campaigntDatas: options, campaignOptions: options })
        },
        usertoken,
      );
    } catch (e) {
      console.log("Error " + e);
      setLoading(false);
    }
  };

  function downloadScheduleAsCSV(
    data,
    filename = "medialog.csv",
    brandName = "",
  ) {
    const rows = [
      [
        "Workspace",
        "Date",
        "Hour Range",
        "File ID",
        "File Name",
        "File Type",
        "Screen Names",
        "Total Count Time",
        "Total Duration Seconds",
      ],
    ];

    data.forEach((day) => {
      const date = day.date;
      day.hours.forEach((hour) => {
        const range = hour.range;
        hour.data.forEach((file) => {
          rows.push([
            brandName,
            date,
            range,
            file.FileID,
            `"${file.FileName}"`, // Handle commas in names
            file.FileType,
            `"${file.ScreenNames.join(", ")}"`,
            file.TotalCountTime,
            file.TotalDurationSeconds,
          ]);
        });
      });
    });

    // Convert array to CSV string
    const csvContent = rows.map((row) => row.join(",")).join("\n");

    // Add UTF-8 BOM to fix Thai character issue in Excel
    const csvWithBOM = "\uFEFF" + csvContent;

    // Create and trigger download
    const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
    // const blob = new Blob([csvWithBOM], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // console.log("csvContent " + csvContent)
    // var encodedUri = encodeURI(csvContent);
    // window.open(encodedUri);
  }

  const setDateRange = (dates) => {
    if (filterRef.current) {
      console.log("has filterRef " + JSON.stringify(dates));
      filterRef.current.setDateRange(dates);
    } else {
      console.log("no filterRef");
    }
  };

  const onExport = () => {
    const { usertoken, requestServerGet, selectedBrandData } = props;
    if (!selectedBrandData) return;

    downloadScheduleAsCSV(
      mediaLogData,
      "medialog.csv",
      selectedBrandData.BrandName,
    );
  };
  const onPageChange = (page, pageSize) => {
    setPage(page);
  };
  return (
    <MainLayout
      id={Constants.MEDIALOG_PAGE}
      quietTitleBar={true}
      style={{ padding: 20 }}
      showTopBarBrandLogo={true}
      showSearchBar={true}
    >
      <motion.div {...Animations.PAGE_ENTER}>
        {/* Page header */}
        <div className="cms-page-header">
          <div className="cms-page-header-info">
            <div
              className="cms-page-header-icon"
              style={{ background: "linear-gradient(135deg,#10b981,#059669)" }}
            >
              <Film size={26} color="#fff" />
            </div>
            <div className="cms-page-header-text">
              <div className="cms-page-header-title">{t.pageTitle}</div>
              <div className="cms-page-header-subtitle">{t.pageSubtitle}</div>
            </div>
          </div>
          <button
            className="cms-page-header-action"
            onClick={onExport}
            style={{
              height: 38,
              padding: "0 18px",
              borderRadius: 8,
              background: "linear-gradient(135deg,#10b981,#059669)",
              color: "#fff",
              border: "none",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Download size={14} color="#fff" /> {t.exportCsv}
          </button>
        </div>

        {/* Filter card */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            border: "1px solid #f1f5f9",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            marginBottom: 16,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 20px",
              borderBottom: "1px solid #f1f5f9",
              background: "#fafbfc",
            }}
          >
            <span
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#0f172a",
                letterSpacing: "0.02em",
              }}
            >
              {t.filters}
            </span>
          </div>
          <div style={{ padding: "14px 20px" }}>
            <MediaLogFilter
              ref={filterRef}
              onFilterChange={setFilter}
              parentProps={props}
            />
          </div>
        </div>

        {/* Spinner */}
        {loading && <PageLoader text={t.loading} />}

        {/* Empty state */}
        {!loading && (!mediaLogData || mediaLogData.length === 0) && (
          <div
            style={{
              background: "#fff",
              borderRadius: 16,
              border: "1px solid #f1f5f9",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "60px 20px",
              gap: 12,
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                background: "linear-gradient(135deg,#10b981,#059669)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Film size={26} color="#fff" />
            </div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#0f172a" }}>
              {t.noDataTitle}
            </div>
            <div style={{ fontSize: 13, color: "#94a3b8" }}>
              {t.noDataSubtitle}
            </div>
          </div>
        )}

        {/* Tabs by date */}
        {!loading && mediaLogData && mediaLogData.length > 0 && (
          <div
            style={{
              background: "#fff",
              borderRadius: 16,
              border: "1px solid #f1f5f9",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              overflow: "hidden",
            }}
          >
            <Tabs
              onChange={() => {
                setLoading(true);
                setTimeout(() => setLoading(false), 300);
              }}
              type="line"
              size="middle"
              tabPosition="top"
              centered
              style={{ padding: "0 16px" }}
              items={mediaLogData.map((dateData, i) => ({
                label: (
                  <span style={{ fontWeight: 600, fontSize: 13 }}>
                    {formatDate(dateData.date)}
                  </span>
                ),
                key: i,
                children: (
                  <div style={{ padding: "0 4px 16px" }}>
                    <Collapse
                      accordion
                      bordered={false}
                      style={{ background: "transparent" }}
                    >
                      {dateData.hours &&
                        dateData.hours.map((hour, index) => {
                          const hasData = hour.data && hour.data.length > 0;
                          return (
                            <Panel
                              key={index}
                              collapsible={hasData ? undefined : "disabled"}
                              style={{
                                background: "#fff",
                                borderRadius: 10,
                                marginBottom: 6,
                                border: "1px solid #f1f5f9",
                                overflow: "hidden",
                              }}
                              header={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                  }}
                                >
                                  <Clock
                                    size={14}
                                    color={hasData ? "#10b981" : "#cbd5e1"}
                                  />
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 13,
                                      color: hasData ? "#0f172a" : "#94a3b8",
                                    }}
                                  >
                                    {formatTimeRange(hour.range)}
                                  </span>
                                  <span
                                    style={{
                                      marginLeft: 4,
                                      padding: "1px 8px",
                                      borderRadius: 20,
                                      fontSize: 11,
                                      fontWeight: 700,
                                      background: hasData
                                        ? "#dcfce7"
                                        : "#f1f5f9",
                                      color: hasData ? "#16a34a" : "#94a3b8",
                                    }}
                                  >
                                    {t.items(hour.data.length)}
                                  </span>
                                </div>
                              }
                            >
                              {hasData && (
                                <Table
                                  columns={columns}
                                  dataSource={hour.data}
                                  pagination={false}
                                  size="small"
                                  rowKey={(r, idx) => `${r.FileID}-${idx}`}
                                  style={{ borderRadius: 0 }}
                                />
                              )}
                            </Panel>
                          );
                        })}
                    </Collapse>
                  </div>
                ),
              }))}
            />
          </div>
        )}
      </motion.div>
    </MainLayout>
  );
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
  };
};

export default connect(mapStateToProps, {
  updateGlobalSearch,
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(MediaLogPage);
